






























import Vue from "vue";

import pagination, { PaginationForm } from "@/common/mixins/pagination";
import { Permission } from "../models/Permission";

export default Vue.extend({
  mixins: [pagination],
  data() {
    const permissions: Permission[] = [];

    return { permissions };
  },
  async created() {
    (this as any).getPaginationRouteQuery();

    await Promise.all([this.getPermissions()]);
  },
  watch: {
    async "$route.query"() {
      await this.getPermissions();
    }
  },
  methods: {
    async getPermissions() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };

      try {
        const {
          data,
          meta
        } = await (this as any).$dep.permissionUseCase.getPermissions(form);

        this.permissions = data;
        (this as any).setPaginationMeta(meta);
      } catch (error) {
        console.log(error.response);
      }
    }
  }
});
